import { useSearchParams } from 'next/navigation';

export default function useInheritParams(path: string, inheritParams: string[]) {
    const searchParams = useSearchParams();
    const pathParts = path.split('?');
    const pathParams = new URLSearchParams(pathParts[1]);

    const overrides = new Map<string, string>();
    const inheritParamsLower = inheritParams.map((param) => param.toLowerCase());

    if (typeof window !== 'undefined') {
        let sessionParams:URLSearchParams|undefined;

        try {
            sessionParams = new URLSearchParams(window.sessionStorage.getItem('paramStr') || '');
        } catch(e) {
            console.error(e);
        }

        if (sessionParams) {
            const keys = sessionParams.keys();
            let key = keys.next().value;

            while (key) {
                if (inheritParamsLower.indexOf(key.toLowerCase()) !== -1) {
                    const value = sessionParams.get(key);
                    if (value) {
                        overrides.set(key, value);
                    }
                }
                key = keys.next().value;
            }
        }
    }

    if (searchParams) {
        searchParams.forEach((value, key) => {
            if (value && inheritParamsLower.indexOf(key.toLowerCase()) !== -1) {
                overrides.set(key, value);
            }
        });
    }

    overrides.forEach((value, key) => {
        const matchingKeys: string[] = [];
        pathParams.forEach((_, paramKey) => {
            if (paramKey.toLowerCase() === key.toLowerCase()) {
                matchingKeys.push(paramKey);
            }
        });
        // Reuse the destination template's existing casing for this param (if any) so downstream
        // consumers that expect a specific case (e.g. lowercase `promocode`) keep seeing it,
        // regardless of the casing the visitor's URL or session storage happened to use.
        const targetKey = matchingKeys[0] || key;
        matchingKeys.forEach((k) => pathParams.delete(k));
        pathParams.set(targetKey, value);
    });

    if (/\/stella\/offer\/purchase\/plan(?:[/?#]|$)/i.test(path)) {
        const satCode = searchParams.get('satcode') || searchParams.get('satCode');
        const targetCodeParam = Array.from(pathParams.keys()).find((key) => {
            const normalizedKey = key.toLowerCase();

            return normalizedKey === 'promocode' || normalizedKey === 'programcode';
        });

        if (satCode && targetCodeParam) {
            pathParams.set(targetCodeParam, satCode);
        }
    } else if (/\/subscribe\/checkout\/(flepz|purchase\/satellite)/gi.test(path)) {
        const satCode = searchParams.get('satcode') || searchParams.get('satCode');

        if (satCode) {
            if (pathParams.has('promoCode') || pathParams.has('promocode')) {
                pathParams.delete('promoCode');
                pathParams.delete('promocode');
                pathParams.set('promoCode', satCode);
            } else {
                pathParams.delete('programCode');
                pathParams.delete('programcode');
                pathParams.set('programcode', satCode);
            }
        }
    } else if (/\/subscribe\/checkout\/purchase\/(streaming|satellite)/gi.test(path)) {
        const strCode = searchParams.get('strcode') || searchParams.get('strCode');

        if (strCode) {
            if (pathParams.has('programCode') || pathParams.has('programcode')) {
                pathParams.delete('programCode');
                pathParams.delete('programcode');
                pathParams.set('programcode', strCode);
            } else {
                pathParams.delete('promoCode');
                pathParams.delete('promocode');
                pathParams.set('promoCode', strCode);
            }
        }
    }

    const nextQuery = pathParams.toString();
    const nextHref = nextQuery ? `${pathParts[0]}?${nextQuery}` : pathParts[0];

    return nextHref;
}
